import * as React from 'react'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

export const NoDetails = () => {
  return (
    <Alert severity={'info'}>
      <AlertTitle>
        {' '}
        <Typography variant="subtitle1" sx={{ fontWeight: '500' }}>
          Details not available
        </Typography>
      </AlertTitle>
      This may have happened because we were unable to find a property record
      for the provided service location.
    </Alert>
  )
}
